import { render } from "./SelectWorkspace.vue?vue&type=template&id=a1a0d8ae&scoped=true&ts=true"
import script from "./SelectWorkspace.vue?vue&type=script&lang=ts"
export * from "./SelectWorkspace.vue?vue&type=script&lang=ts"

import "./SelectWorkspace.vue?vue&type=style&index=0&id=a1a0d8ae&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1a0d8ae"]])

export default __exports__